(function () {
    'use strict';
    angular
        .module('blocks.modal')
        .controller('modalsController', modalsController);

    modalsController.$inject = ['$uibModalInstance','modalModel','modalSettings'];
    /*@ngInject*/
    function modalsController($uibModalInstance, modalModel, modalSettings) {
        var vm = this;
        vm.options = modalSettings.options;
        vm.title = modalSettings.title;

        vm.ok = function () {
            $uibModalInstance.close({message:'test'});
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


        vm.selectOption = function (position) {
            $uibModalInstance.dismiss('open new modal');
            vm.options[position].openModalPromise(modalModel, modalSettings.closeCallback);
        };
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/modal/obt-modals.controller.js
 ** module id = 89
 ** module chunks = 0
 **/